import * as React from 'react';
type Props = {
  className?: string;
};
export function EyeOpen({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-EyeOpen"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0004 4C7.3715 4 4.24213 6.14781 2.81811 9.24588C2.59839 9.7239 2.59839 10.2761 2.81811 10.7541C4.24213 13.8522 7.3715 16 11.0004 16C14.6293 16 17.7587 13.8522 19.1827 10.7541C19.4025 10.2761 19.4025 9.7239 19.1827 9.24588C17.7587 6.14781 14.6293 4 11.0004 4ZM1.00089 8.4106C2.73907 4.62904 6.56168 2 11.0004 2C15.4392 2 19.2618 4.62905 21 8.4106C21.4634 9.41881 21.4634 10.5812 21 11.5894C19.2618 15.371 15.4392 18 11.0004 18C6.56168 18 2.73907 15.371 1.00089 11.5894C0.537465 10.5812 0.537465 9.41881 1.00089 8.4106ZM11.0004 8C9.89585 8 9.00042 8.89543 9.00042 10C9.00042 11.1046 9.89585 12 11.0004 12C12.105 12 13.0004 11.1046 13.0004 10C13.0004 8.89543 12.105 8 11.0004 8ZM7.00042 10C7.00042 7.79086 8.79128 6 11.0004 6C13.2096 6 15.0004 7.79086 15.0004 10C15.0004 12.2091 13.2096 14 11.0004 14C8.79128 14 7.00042 12.2091 7.00042 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
